import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.AllRequestsMenu', {
    allRequestsName: 'All requests',
    requiresMyDecisionName: 'Requires my approval',
    requiresMyReviewName: 'Requires my review',
    onHold: 'On hold',
});
